import client from './client'
import type {
  DocCategorySummary,
  DocArticleListItem,
  DocArticle,
  DocSearchEntry,
  SubmitDocFeedbackPayload,
} from '@/types/docs'

const BASE = '/public/docs'

export async function fetchDocCategories(locale: string): Promise<DocCategorySummary[]> {
  const { data } = await client.get<{ data: DocCategorySummary[] }>(
    `${BASE}/categories`,
    { params: { locale } },
  )
  return data.data
}

export async function fetchDocCategory(
  category: string,
  locale: string,
): Promise<DocArticleListItem[]> {
  const { data } = await client.get<{ data: DocArticleListItem[] }>(
    `${BASE}/${category}`,
    { params: { locale } },
  )
  return data.data
}

export async function fetchDocArticle(
  category: string,
  slug: string,
  locale: string,
): Promise<DocArticle> {
  const { data } = await client.get<{ data: DocArticle }>(
    `${BASE}/${category}/${slug}`,
    { params: { locale } },
  )
  return data.data
}

export async function fetchDocSearchIndex(locale: string): Promise<DocSearchEntry[]> {
  const { data } = await client.get<DocSearchEntry[]>(
    `${BASE}/search-index`,
    { params: { locale } },
  )
  // The search-index endpoint returns a flat array (not wrapped in data.data)
  return data
}

export async function submitDocFeedback(
  category: string,
  slug: string,
  payload: SubmitDocFeedbackPayload,
): Promise<void> {
  await client.post(
    `${BASE}/${category}/${slug}/feedback`,
    payload,
  )
}
